"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var TextSizes = exports.TextSizes = {
	WeightLight: process.env.REACT_APP_TextSizes_WeightLight,
	WeightNormal: process.env.REACT_APP_TextSizes_WeightNormal,
	WeightMedium: process.env.REACT_APP_TextSizes_WeightMedium,
	WeightSemiBold: process.env.REACT_APP_TextSizes_WeightSemiBold,

	LineSpacingBody: process.env.REACT_APP_TextSizes_LineSpacingBody,

	D1FontSize: process.env.REACT_APP_TextSizes_D1FontSize,
	D1FontWeight: process.env.REACT_APP_TextSizes_D1FontWeight,
	D1LineHeight: process.env.REACT_APP_TextSizes_D1LineHeight,

	D2FontSize: process.env.REACT_APP_TextSizes_D2FontSize,
	D2FontWeight: process.env.REACT_APP_TextSizes_D2FontWeight,
	D2LineHeight: process.env.REACT_APP_TextSizes_D2LineHeight,

	D3FontSize: process.env.REACT_APP_TextSizes_D3FontSize,
	D3FontWeight: process.env.REACT_APP_TextSizes_D3FontWeight,
	D3LineHeight: process.env.REACT_APP_TextSizes_D3LineHeight,

	D4FontSize: process.env.REACT_APP_TextSizes_D4FontSize,
	D4FontWeight: process.env.REACT_APP_TextSizes_D4FontWeight,
	D4LineHeight: process.env.REACT_APP_TextSizes_D4LineHeight,

	DisplayFontFamily: process.env.REACT_APP_TextSizes_DisplayFontFamily,

	H1FontSize: process.env.REACT_APP_TextSizes_H1FontSize,
	H1FontWeight: process.env.REACT_APP_TextSizes_H1FontWeight,
	H1LineHeight: process.env.REACT_APP_TextSizes_H1LineHeight,

	H2FontSize: process.env.REACT_APP_TextSizes_H2FontSize,
	H2FontWeight: process.env.REACT_APP_TextSizes_H2FontWeight,
	H2LineHeight: process.env.REACT_APP_TextSizes_H2LineHeight,

	H3FontSize: process.env.REACT_APP_TextSizes_H3FontSize,
	H3FontWeight: process.env.REACT_APP_TextSizes_H3FontWeight,
	H3LineHeight: process.env.REACT_APP_TextSizes_H3LineHeight,

	H4FontSize: process.env.REACT_APP_TextSizes_H4FontSize,
	H4FontWeight: process.env.REACT_APP_TextSizes_H4FontWeight,
	H4LineHeight: process.env.REACT_APP_TextSizes_H4LineHeight,

	H5FontSize: process.env.REACT_APP_TextSizes_H5FontSize,
	H5FontWeight: process.env.REACT_APP_TextSizes_H5FontWeight,
	H5LineHeight: process.env.REACT_APP_TextSizes_H5LineHeight,

	H6FontSize: process.env.REACT_APP_TextSizes_H6FontSize,
	H6FontWeight: process.env.REACT_APP_TextSizes_H6FontWeight,
	H6LineHeight: process.env.REACT_APP_TextSizes_H6LineHeight,

	HeaderFontFamily: process.env.REACT_APP_TextSizes_HeaderFontFamily,

	P1FontSize: process.env.REACT_APP_TextSizes_P1FontSize,
	P1LineHeight: process.env.REACT_APP_TextSizes_P1LineHeight,

	P2FontSize: process.env.REACT_APP_TextSizes_P2FontSize,
	P2LineHeight: process.env.REACT_APP_TextSizes_P2LineHeight,

	P3FontSize: process.env.REACT_APP_TextSizes_P3FontSize,
	P3LineHeight: process.env.REACT_APP_TextSizes_P3LineHeight,

	P4FontSize: process.env.REACT_APP_TextSizes_P4FontSize,
	P4LineHeight: process.env.REACT_APP_TextSizes_P4LineHeight,

	ParagraphFontFamily: process.env.REACT_APP_TextSizes_ParagraphFontFamily,
	ParagraphLetterSpacing: process.env.REACT_APP_TextSizes_ParagraphLetterSpacing,

	ButtonFontSize: process.env.REACT_APP_TextSizes_ButtonFontSize,
	ButtonLineHeight: process.env.REACT_APP_TextSizes_ButtonLineHeight
};